import type { ControlCardEquipment } from '../infrastructure'
import type { GenerateControlCardRequest } from './dtos/ControlCardDTOs'

/**
 * 48-month inspections renew NDT. Preview must show the new date before
 * publish writes it to the database.
 */
export function resolveNdtDateOverride(request: GenerateControlCardRequest): string | undefined {
  return (
    request.options?.ndtDateOverride ||
    (request.inspection.jobType === '48 måneder' ? request.inspection.performedDate : undefined)
  )
}

export function withNdtDateOverride(
  equipment: ControlCardEquipment,
  isoDate: string | undefined
): ControlCardEquipment {
  if (!isoDate) return equipment
  return {
    ...equipment,
    specifications: equipment.specifications.withNdtDate(isoDate, equipment.category),
  }
}
